import Vue from 'vue'
import { alteredSlideGroups } from '@/data/discover/alteredSlides'

export default {

    adjustSlides( state, { /*userName, */userType })
    {
        if (typeof userType != 'string') return;

        alteredSlideGroups.forEach(({ slides, stories }, group) => { 
            if (slides) {
                Vue.set(state.slides[group], 'circles', slides[userType])
            }
            if (stories) {
                Vue.set(state.stories[group], 'stories', stories[userType])
                // console.log( stories[userType] )
            }
        })
    },
    setGroupedStories( state ) {

        alteredSlideGroups.forEach(({ stories }, group) => { 
            if (stories) {
                Vue.set(state.stories[group], 'grouped', flattenGroupedStories(stories))
            }
        })
    },
    setRandomStories( state ) {

        state.stories.forEach( function(slide, group)
        {
            if ( !Array.isArray(slide.stories) ) return;

            slide.stories.forEach( function(story, x) 
            {
                if ( !Array.isArray(story) ) return;

                const random = Math.min(Math.floor(Math.random() * story.length))
                const selectedStory = story[random]

                state.slides[group].circles[x].media = selectedStory.author.name.replace(' ', '_')
                state.stories[group].stories[x] = selectedStory

                // Vue.set(state.slides[group].circles, x, {
                //     ...state.slides[group].circles[x],
                //     media: selectedStory.author.name.replace(' ', '_')
                // })

                // Vue.set(state.stories[group].stories, x, selectedStory)
            })

        })

    }
}

function flattenGroupedStories({ experienced = [], student = [] }) {
    const mergedResult = [];
    const maxLength = Math.max(experienced.length, student.length);

    for (let i = 0; i < maxLength; i++) {
        const combinedArray = [
            ...(Array.isArray(experienced[i]) ? experienced[i] : []), 
            ...(Array.isArray(student[i]) ? student[i] : [])
        ]

        const seenNames = new Set();
        const deduplicatedArray = combinedArray.filter(item => {
            const { name: authorName } = item.author
            if (authorName && !seenNames.has(authorName)) {
                seenNames.add(authorName)
                return true
            }
            return false
        })

        mergedResult.push(deduplicatedArray)
    }

    return mergedResult
}